import { http, HttpResponse } from 'msw';

import { env } from '@/config/env';
import { axios } from '@/lib/axios';
import { networkDelay } from '@/test/mocks/utils';

export type PCFeedbackPayload = {
  session_id: string;
  student_id: string;
  overall_experience: number;
  progress_explained_clearly?: string;
  happy_with_progress?: string;
  concerns_addressed?: string;
  additional_feedback?: string;
  origin?: string;
};

export type PCFeedbackResponse = {
  status: string;
  message: string;
};

export const submitPCFeedback = (
  payload: PCFeedbackPayload
): Promise<PCFeedbackResponse> =>
  axios.post('/batches/v1/batch/ptm-student-trainer-feedback', payload);

export const submitPCFeedbackMockHandler = http.post(
  `${env.API_URL}/batches/v1/batch/ptm-student-trainer-feedback`,
  async (): Promise<HttpResponse<PCFeedbackResponse>> => {
    await networkDelay();
    return HttpResponse.json({
      status: 'success',
      message: 'Feedback submitted successfully',
    });
  }
);
